import { ApolloClient, InMemoryCache, HttpLink, PureQueryOptions } from '@apollo/client/core';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { sha256 } from 'crypto-hash';
import { print } from 'graphql';
import config from '../config/api.config';

interface GraphqlData<T = any> {
  data: T;
}

function persistedQuery(url: string) {
  const httpLink = new HttpLink({ uri: url });
  const linkChain = createPersistedQueryLink({
    useGETForHashedQueries: true,
    generateHash: async (document) => {
      return await sha256(print(document));
    },
  }).concat(httpLink);

  return linkChain;
}

// Cache implementation
const link = persistedQuery(config.contentApiUrl);

const cache = new InMemoryCache();

export async function handleApolloClientRequest<T>(options: PureQueryOptions) {
  switch (true) {
    case 'query' in options: {
      const { data } = await apolloClient.query<GraphqlData<T>>(options as PureQueryOptions);
      return data.data || (data as unknown as T);
    }
    default:
      throw new Error('Wrong Apollo client fetch type');
  }
}

const apolloClient = new ApolloClient({
  link,
  cache,
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'none',
    },
  },
});

export default apolloClient;
